import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var PriceSummary = function PriceSummary(_ref) {
  var description = _ref.description,
      price = _ref.price,
      summaryClassNames = _ref.summaryClassNames,
      dataCy = _ref.dataCy;
  return /*#__PURE__*/_jsxs("div", {
    className: "border-top bc-gray-10 flex justify-between py3 ".concat(summaryClassNames),
    "data-cy": dataCy,
    children: [/*#__PURE__*/_jsx("span", {
      children: description
    }), /*#__PURE__*/_jsx("span", {
      children: price
    })]
  });
};
PriceSummary.defaultProps = {
  summaryClassNames: ''
};